module.exports = __webpack_public_path__ + "img/国家高新技术企业.5ab1f3b1.svg";